import React, { useState, useEffect } from 'react';
import WithdrawUSD from './WithdrawOptions/WithdrawUSD';
import WithdrawCrypto from './WithdrawOptions/WithdrawCrypto';
const WithdrawModal = ({
   isOpen,
   onClose,
   initialStep = 1,
   initialCrypto = null,
   directSend = false,
   skipToSend = false,
   goToWithdrawUSD = false // Nuevo prop para manejar retiro directo de USD
}) => {
   const [currentStep, setCurrentStep] = useState(initialStep);
   const [selectedWithdrawType, setSelectedWithdrawType] = useState('');
   const [selectedCrypto, setSelectedCrypto] = useState(null);
   // Este efecto se encargará de configurar el modal correctamente cuando se abre
   useEffect(() => {
      if (isOpen) {
         setCurrentStep(initialStep);
         // Si es retiro directo de USD
         if (goToWithdrawUSD) {
            setSelectedWithdrawType('usd');
            // No es necesario avanzar más pasos ya que el tipo 'usd' mostrará el componente WithdrawUSD
         }
         // Manejo existente para envío de crypto
         else if ((directSend || skipToSend) && initialCrypto) {
            setSelectedWithdrawType('crypto');
            setSelectedCrypto(initialCrypto);
            setTimeout(() => {
               setCurrentStep(3); // O el paso que corresponda al envío
            }, 50);
         }
      } else {
         // Resetear estados cuando se cierra el modal
         setSelectedWithdrawType('');
         setSelectedCrypto(null);
         setCurrentStep(1);
      }
   }, [isOpen, initialStep, initialCrypto, directSend, skipToSend, goToWithdrawUSD]);
   if (!isOpen) return null;
   const handleOverlayClick = (e) => {
      if (e.target.className === 'modal_overlay') {
         onClose();
      }
   };
   const handleOptionSelect = (option) => {
      setSelectedWithdrawType(option);
   };
   const handleBack = () => {
      setSelectedWithdrawType('');
   };
   return (
      <div className="modal_overlay" onClick={handleOverlayClick}>
         <div className="modal_content">
            <div className="modal_content_header">
               <span onClick={onClose} className="modal_content_header_close"></span>
            </div>
            <div className="modal_content_body">
               {selectedWithdrawType === '' ? (
                  <>
                     <h3 className="ppt_form_title mb-5 text-center">Withdraw</h3>
                     <div className='ppt_deposit_ex text-center gap-3'>
                        <div
                           className='ppt_deposit_item anchor'
                           onClick={() => handleOptionSelect('usd')}
                        >
                           <div className='ppt_deposit_item_imgs'>
                              <img src={process.env.PUBLIC_URL + '/assets/img/lm_icon_dollar.svg'} alt="" />
                           </div>
                           <p>Withdraw<br /> USD</p>
                        </div>
                        <div
                           className='ppt_deposit_item anchor'
                           onClick={() => handleOptionSelect('crypto')}
                        >
                           <div className='ppt_deposit_item_imgs'>
                              <img src={process.env.PUBLIC_URL + '/assets/img/icon_propt_n.svg'} alt="" />
                              <img src={process.env.PUBLIC_URL + '/assets/img/icon_btc.svg'} alt="" />
                              <img src={process.env.PUBLIC_URL + '/assets/img/icon_usdc.svg'} alt="" />
                           </div>
                           <p>Withdraw Crypto<br /> and Stablecoin</p>
                        </div>
                     </div>
                  </>
               ) : (
                  <>
                     {selectedWithdrawType === 'usd' && <WithdrawUSD onBack={handleBack} />}
                     {selectedWithdrawType === 'crypto' && (
                        <WithdrawCrypto
                           onBack={handleBack}
                           initialCrypto={initialCrypto}
                           currentStep={currentStep}
                           setCurrentStep={setCurrentStep}
                           directSend={directSend || skipToSend}
                        />
                     )}
                  </>
               )}
            </div>
         </div>
      </div>
   );
};
export default WithdrawModal;
